export default [
    function BrandRootController() {
        // TODO: Potentially move config $rootScope decoration into BrandRoot.
    }
];
